import '../assets/SimpleSearch.css';const l = "op_searchHolder_rpRWL", o = "op_search_nc58L", e = {
  searchHolder: l,
  search: o
};
function n(t) {
  let {
    searchTerm: a = "",
    onChange: r,
    path: c,
    attributes: s = {},
    holderAttributes: h = {}
  } = t;
  return /* @__PURE__ */ React.createElement("div", { ...h, className: e.searchHolder }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      className: e.search,
      value: a,
      onChange: r,
      "data-path": c,
      placeholder: "🔎︎ Start typing here to search",
      ...s
    }
  ));
}
export {
  n as SimpleSearch
};
